import { Route, Routes, useLocation } from 'react-router-dom';

import React, { useContext } from 'react';
import { CustomerContext } from '../context/customerContext';
import MainLayout from '../layouts/MainLayout';
import OnBoardingLayout from '../layouts/OnBoardingLayout';
import Connectors from '../pages/Connectors/Connectors';
import HomeDemo from '../pages/Demo/HomeDemo';
import PartnerStoreDemo from '../pages/Demo/PartnerStoreDemo/PartnerStoreDemo';
import DashboardDemo from '../pages/Demo/PerformanceDemo/PerformanceDemo';
import OnBoardingForm from '../pages/OnBoarding/OnBoardingForm';
import TermsAndPrivacy from '../pages/TermsAndPrivacy';
import TwelveConnect from '../pages/TwelveConnect';
import { ProtectedRoute, RedirectOnBoardingRoute } from './RedirectRoutes';

function DemoApp({ loginComponent, isAuthenticated }) {
  const { customer, isCustomerLoading, loginCustomer } =
    useContext(CustomerContext);

  const location = useLocation();
  const withSideBar = ['/', '/performance', '/partner-store'].includes(
    location.pathname
  );

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route element={<OnBoardingLayout />}>
          <Route
            path="/"
            index
            element={React.cloneElement(loginComponent, {
              onLoginSuccess: loginCustomer,
            })}
          />
        </Route>
        <Route
          path="*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <OnBoardingLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <OnBoardingLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/onboarding" element={<OnBoardingForm />} />
        <Route
          path="/privacy-policy"
          element={<TermsAndPrivacy isPrivacy={true} />}
        />
        <Route
          path="/terms-of-use"
          element={<TermsAndPrivacy isTerms={true} />}
        />
      </Route>

      <Route
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <RedirectOnBoardingRoute customer={customer}>
              <MainLayout
                withSideBar={withSideBar}
                loading={isCustomerLoading}
              />
            </RedirectOnBoardingRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/" index element={<HomeDemo />} />
        <Route path="/performance" element={<DashboardDemo />} />
        <Route path="/partner-store" element={<PartnerStoreDemo />} />
        <Route path="/twelve-connect" element={<TwelveConnect />} />
        <Route path="/connectors" element={<Connectors />} />
      </Route>
    </Routes>
  );
}

export default DemoApp;
